import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { MUIViewer } from "../../MUI/Viewer";
import { _viewport, tl } from "../../../../utils";
import { Box, Button, ButtonGroup, Checkbox, Grid } from "@material-ui/core";
import * as styles from "./styles.scss";
import { SvgIcon } from "../../../../components";
import FSStore from "../store";
import FSViewerStore from "./store";

interface IProps {
  onClose?: any;
}

export const Viewer = observer((props: IProps) => {
  const { fsStore, fsViewerStore } = React.useContext<{
    fsStore: FSStore;
    fsViewerStore: FSViewerStore;
  }>(MobXProviderContext);

  return fsViewerStore.isVisible ? (
    <MUIViewer
      onClose={fsViewerStore.hideViewer}
      currentId={fsViewerStore.currentId}
      itemsList={fsViewerStore.files}
      showItem={fsViewerStore.showFile}
      currentItem={fsViewerStore.currentFile}
      currentVideo={fsViewerStore.currentVideo}
    >
      <Box pt={2}>
        <Grid container spacing={2}>
          <Grid item xs>
            {!fsStore.onProtect ? null : (
              <Button variant="contained" type="button">
                <SvgIcon type="fs-protect" />
              </Button>
            )}
          </Grid>
          <Grid item>
            <ButtonGroup
              variant="text"
              disableRipple
              className={styles.controls}
            >
              {fsStore.canEdit ? (
                <Button
                  href={`/panel/files/edit?course_id=${fsViewerStore.currentFile.course}&id=${fsViewerStore.currentFile.id}`}
                  target="_blank"
                  startIcon={<SvgIcon type="fs-list-settings" />}
                >
                  {tl("Настройки")}
                </Button>
              ) : null}
              {fsStore.canDownload ? (
                <Button
                  href={fsViewerStore.currentFile.downloadUrl}
                  target="_blank"
                  startIcon={<SvgIcon type="fs-list-download" />}
                >
                  {tl("Скачать")}
                </Button>
              ) : null}
            </ButtonGroup>
          </Grid>
          {!fsStore.onAttach ? null : (
            <Grid item className={styles.viewerBlock__panelAttach}>
              {!fsStore.getCheckedFilesCount ? (
                <Button
                  variant="contained"
                  type="button"
                  startIcon={<SvgIcon type="fs-attach" />}
                  onClick={() => {
                    fsViewerStore.hideViewer();
                    fsStore.onAttachAll([fsViewerStore.currentFile]);
                  }}
                >
                  {tl("Прикрепить")}
                </Button>
              ) : (
                <Button
                  component="label"
                  variant="contained"
                  htmlFor={`filestorage-fileCheck-${fsViewerStore.currentFile.id}`}
                  onClick={fsViewerStore.currentFileCheckToggle}
                  startIcon={
                    <Checkbox
                      color="primary"
                      disableRipple
                      checked={fsViewerStore.isCurrentFileChecked}
                      readOnly
                      tabIndex={-1}
                    />
                  }
                  className="MuiButton-check"
                >
                  {fsViewerStore.isCurrentFileChecked ? "Выбран" : "Выбрать"}
                </Button>
              )}
            </Grid>
          )}
        </Grid>
      </Box>
    </MUIViewer>
  ) : null;
});
